import React from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { IconButton } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

export default function Notifications() {
    return (
        <SnackbarProvider
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            maxSnack={1}
            Components={{
                success: OutlinedAlert('success'),
                error: OutlinedAlert('error'),
                warning: OutlinedAlert('warning'),
                info: OutlinedAlert('info'),
                default: OutlinedAlert('info')
            }}
        />
    );
}

function SnackbarCloseButton({ snackbarKey }) {
    const { closeSnackbar } = useSnackbar();

    return (
        <IconButton onClick={() => closeSnackbar(snackbarKey)} size='small' color='inherit'>
            <CloseRounded fontSize='small' />
        </IconButton>
    );
}

const OutlinedAlert = severity =>
    React.forwardRef(function OutlinedAlertComponent(props, ref) {
        const { message, snackbarKey } = props;
        return (
            <Alert
                ref={ref}
                variant='standard'
                severity={severity}
                action={<SnackbarCloseButton snackbarKey={snackbarKey} />}
            >
                {message}
            </Alert>
        );
    });
